import React from 'react';

import { useGameDetails } from 'utils/Hooks';
import CardCurrent from 'components/CardCurrent';
import CardNext from 'components/CardNext';
import CardPrevious from 'components/CardPrevious';
import StoplightCard from 'components/Stoplight';
// import MiscWidgets from 'components/Widgets/widgets';
import Chart from 'pages/Chart';
import { DogeChainDisclaimer } from './disclaimers';
import Metadata from 'components/Metadata'
import GameStatus from 'components/GameStatus';
import 'pages/styles.scss';
import './styles.scss';


function PredictionDesktop(props) {
  const gameDetails = useGameDetails();

  if (props.newestRoundID == 0)
    return;
  else
    return (<React.Fragment>
      <Metadata
        title={`${gameDetails.tickerSymbol} Price Prediction Game`}
        link='/prediction'
        description={`Predict price movements of ${gameDetails.tickerSymbol} and win crypto if you're correct`}
      />
      <div id='Predict' className='PredictionContent Desktop' >
        <div className="container mx-auto">
          <div className='Cards'>
            <GameStatus />
            <CardPrevious
              key={props.newestRoundID - 2}
            />
            <CardCurrent
              key={props.newestRoundID - 1}
              OnLoad={props.OnLoad} // the slowest-loading card; it decides when page is fully loaded
            />
            <CardNext
              key={props.newestRoundID}
            />
            <StoplightCard />
          </div>
          <DogeChainDisclaimer />
        </div>
        <div className='PredictionPageNavLinkContainer'>
          <a className='ThemeButtonAux' href='#chart'>
            See Chart
          </a>
        </div>
      </div>
      <div id='chart' className='DesktopChart'>
        <Chart />
        <div className='PredictionPageNavLinkContainer'>
          <a className='ThemeButtonAux' href='#cards'>
            See Cards
          </a>
        </div>
      </div>
    </React.Fragment>);
}

export default PredictionDesktop;
